import { getCatalogSearchedFiltersArgsToParams } from 'data/api/transformers/arguments/get-catalog-searched-filters-args-to-params'
import { GetCatalogSearchedFiltersArgs } from 'types/api/arguments/get-catalog-searched-filters-args'
import { GetCatalogSearchedFiltersResp } from 'types/api/response/get-catalog-searched-filters-resp'

import { api } from './api'

export const getCatalogSearchedFilters = (args: GetCatalogSearchedFiltersArgs) =>
  api.get<GetCatalogSearchedFiltersResp>('/catalog/filters/search', {
    params: getCatalogSearchedFiltersArgsToParams(args),
  })
